import { Moment } from 'moment/moment';
import { SelectOption } from '../../../../global';

export enum VOFilterType {
  STAGE = 'STAGE',
  TIERS = 'TIERS',
  STATUS = 'STATUS',
  DISPLAY = 'DISPLAY',
  LOCATION = 'LOCATION',
  SALES_REP = 'SALES_REP',
  SET_OF_DATA = 'SET_OF_DATA',
  CLOSED_DEALS = 'CLOSED_DEALS',
  APPLYING_FOR = 'APPLYING_FOR',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  SALES_MANAGER = 'SALES_MANAGER',
  FINANCE_MANAGER = 'FINANCE_MANAGER',
  OPPORTUNITY_TYPE = 'OPPORTUNITY_TYPE',
  CREATE_DATE_RANGE = 'CREATE_DATE_RANGE',
}

export enum VOFilterDisplayKeys {
  Active = 'Active',
  Testing = 'Testing',
  Duplicate = 'Duplicate',
  Other = 'Other',
}

export enum VOFilterDisplayPayloadValues {
  Active = 100,
  Testing = 200,
  Duplicate = 201,
  Other = 202,
}

export type VOFilters = {
  [VOFilterType.CLOSED_DEALS]: {
    isIncludeClosedDeals: boolean;
  };
  [VOFilterType.CREATE_DATE_RANGE]: {
    from: Moment;
    to: Moment;
  };
  [VOFilterType.DISPLAY]: Record<VOFilterDisplayKeys, boolean>;
  [VOFilterType.STATUS]: SelectOption[];
  [VOFilterType.LOCATION]: SelectOption[];
  [VOFilterType.SALES_REP]: SelectOption[];
  [VOFilterType.SET_OF_DATA]: SelectOption[];
  [VOFilterType.APPLYING_FOR]: SelectOption[];
  [VOFilterType.SALES_MANAGER]: SelectOption[];
  [VOFilterType.FINANCE_MANAGER]: SelectOption[];
  [VOFilterType.OPPORTUNITY_TYPE]: SelectOption[];
  [VOFilterType.STAGE]: Record<string, boolean | undefined>;
  [VOFilterType.TIERS]: Record<string, boolean | undefined>;
  [VOFilterType.PAYMENT_TYPE]: Record<string, boolean | undefined>;
};

export interface VOFilterCardProps {
  meta?: Partial<Record<VOFilterType, SelectOption[]>>;
}

export type VOFiltersFormattedForPayload = {
  [VOFilterType.CREATE_DATE_RANGE]: {
    from: string;
    to: string;
  };
  [VOFilterType.DISPLAY]: string[];
  [VOFilterType.STATUS]: string[];
  [VOFilterType.LOCATION]: string[];
  [VOFilterType.SALES_REP]: string[];
  [VOFilterType.OPPORTUNITY_TYPE]: string[];
  [VOFilterType.APPLYING_FOR]: string[];
  [VOFilterType.SALES_MANAGER]: string[];
  [VOFilterType.FINANCE_MANAGER]: string[];
  [VOFilterType.STAGE]: string[];
  [VOFilterType.TIERS]: string[];
  [VOFilterType.PAYMENT_TYPE]: string[];
};

export type VOFiltersPayloadItem = {
  [K in keyof VOFiltersFormattedForPayload]: {
    key: K;
    value: VOFiltersFormattedForPayload[K];
  };
}[keyof VOFiltersFormattedForPayload];

export type VOFiltersPayload = VOFiltersPayloadItem[];
